
    export const INFO:string ="info";
    export const  SUCCESS:string  ="success";
    export const WARNING:string  ="warning";
    export const ERROR :string ="error";
  